<ng-container [formGroup]="formGroup" class="">
  <mat-form-field>
    <mat-label>{{'Language' | translate}}</mat-label>
    <mat-select [formControlName]="controlName" [id]="controlName"
      (selectionChange)="onSelectionChanged($event)"
      [placeholder]="'Language' | translate">
      @for (language of languages; track language) {
        <mat-option [value]="language.id" >
          {{ language.name | translate }}
        </mat-option>
      }
    </mat-select>
    @if (formGroup.get(controlName).errors?.required) {
      <mat-error>
        {{'Language is required.' | translate}}
      </mat-error>
    }
  </mat-form-field>
</ng-container>
